import React from "react";
import "./TrustedComments.scss";
import { ReactComponent as IconStart } from '../../../assets/svg/commentstar.svg';
import "react-multi-carousel/lib/styles.css";
import CorauselSlider from "../../../utility/components/CorauselSlider";


// Title Component
const TitleComponent = ({ title }) => {
    return (
        <div className="comments__title-container">
            <h1 className="comments-title">{title}</h1>
        </div>
    );
};

// CarouselItem Component
const CarouselItem = ({ src, alt, author, address, comments, starsnumber }) => {
    const imageSrc = require(`../../../assets/img/${src}`);
    return (
        <div className="carousel-card">
            <div className="image-card">
                <img src={imageSrc} alt={alt} />
            </div>

            <div className="comment-card__container">
                <div className="stars-container">
                    {Array.from({ length: starsnumber }).map((_, index) => (
                        <IconStart key={index} />
                    ))}
                </div>

                <div className="comment-information">
                    <p className="comment-author">{author}</p>
                    <p className="comment-address">{address}</p>
                </div>
                <p className="comment-text">{comments}</p>
            </div>
        </div>
    );
};

// TrustedComments Component
export const TrustedComments = () => {
    const items = [
        { src: "trusted-comments-01.jpg", alt: "client image", author: "Anna & Ben,", address: "Hong Kong", comments: "Emina is a very responsible designer, he will adjust the design plan according to our needs in time, this renovation is a perfect experience!.", starsnumber: 5 },
        { src: "comment1.jpg", alt: "client image", author: "John Doe,", address: "New York", comments: "Great experience working with Emina, highly recommended!", starsnumber: 4 },
        { src: "comment2.jpg", alt: "client image", author: "Jane Smith,", address: "London", comments: "Highly recommend Emina for any design work, very professional!", starsnumber: 5 },
        { src: "trusted-comments-01.jpg", alt: "client image", author: "Jane Smith,", address: "London", comments: "Highly recommend Emina for any design work, very professional!", starsnumber: 3 }
    ];


    return (
        <div className="trusted-comments-container">
            <TitleComponent title="Trusted by Homeowners Across Hong Kong" />
            <CorauselSlider cards={items} renderCard={CarouselItem} showProgressBar={false} >
                {items.map((item, index) => (
                    <CarouselItem
                        key={index}
                        src={item.src}
                        alt={item.alt}
                        author={item.author}
                        address={item.address}
                        comments={item.comments}
                        starsnumber={item.starsnumber}
                    />
                ))}
            </CorauselSlider>
        </div>
    );
};
